"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Box } from "@mui/material";
import { Skeleton, Link, Text, List, ListItem, Divider } from "@nxt-costco-com/forge-components";
import { SpaceLg, SpaceMd, SpaceSm, SpaceXxs, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { Plus } from "@nxt-costco-com/forge-icons/icons/Plus";
import { addToListActions } from "../../constants.js";
import { ListCheckBox } from "./ListCheckBox.js";
import { ShowNotification } from "./Notifications/ShowNotification.js";
import { SaveToListButton } from "./SaveToListButton.js";
const ListsUI = (props) => {
  const { state, dispatch, showSticky, checkListHeight, msStore } = props;
  const {
    wishLists,
    drawerContent,
    isLoading,
    globalErrorMsg,
    globalSuccessMsg,
    selectedLists
  } = state;
  const createNewListTitle = msStore.getKeyValueItem("createnewlisttitle");
  const createNewListButtonTitle = msStore.getKeyValueItem(
    "createnewlistbuttontitle"
  );
  useEffect(() => {
    if (isLoading) return;
    if (!wishLists.length) {
      dispatch({
        payload: {
          drawerContent: [
            ...drawerContent,
            {
              bodyContent: "createNewList",
              hasStickyBar: false,
              title: createNewListTitle
            }
          ]
        },
        type: addToListActions.UPDATE_STATE
      });
    } else {
      checkListHeight();
      dispatch({
        payload: {
          drawerContent: drawerContent.filter(
            (drawer) => drawer.bodyContent !== "createNewList"
          )
        },
        type: addToListActions.UPDATE_STATE
      });
    }
  }, [wishLists, isLoading]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          marginTop: SpaceLg
        },
        children: /* @__PURE__ */ jsx(Skeleton, { height: "400px", variant: "rectangular", width: "100%" })
      }
    );
  }
  const listItemStyles = {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    gap: SpaceSm
  };
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          alignItems: "center",
          display: "flex",
          gap: SpaceXxs,
          justifyContent: "flex-end",
          marginBottom: SpaceSm,
          marginTop: SpaceLg,
          paddingRight: SpaceMd
        },
        children: /* @__PURE__ */ jsx(
          Link,
          {
            onClick: (e) => {
              e.preventDefault();
              dispatch({
                payload: {
                  drawerContent: [
                    ...drawerContent,
                    {
                      bodyContent: "createNewList",
                      hasStickyBar: false,
                      title: createNewListTitle
                    }
                  ],
                  errorMsg: "",
                  globalErrorMsg: "",
                  isLoading: false,
                  selectedLists: [],
                  successMsg: ""
                },
                type: addToListActions.UPDATE_STATE
              });
            },
            underline: "none",
            children: /* @__PURE__ */ jsxs(
              Box,
              {
                sx: {
                  alignItems: "center",
                  display: "flex",
                  gap: SpaceXxs
                },
                children: [
                  /* @__PURE__ */ jsx(
                    Plus,
                    {
                      sx: {
                        color: ColorGray900,
                        height: "18px",
                        width: "18px"
                      }
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Text,
                    {
                      component: "button",
                      variant: "t6",
                      style: {
                        background: "none",
                        backgroundColor: "transparent",
                        border: "none",
                        cursor: "pointer",
                        color: ColorGray900,
                        padding: 0,
                        margin: 0
                      },
                      children: createNewListButtonTitle
                    }
                  )
                ]
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "span",
      {
        "aria-live": "polite",
        id: "save-to-list-global-notification",
        tabIndex: -1,
        children: /* @__PURE__ */ jsx(
          ShowNotification,
          {
            errorMsg: globalErrorMsg,
            successMsg: globalSuccessMsg
          }
        )
      }
    ),
    (wishLists == null ? void 0 : wishLists.length) ? /* @__PURE__ */ jsx(
      List,
      {
        sx: {
          display: "flex",
          flexDirection: "column",
          gap: SpaceSm,
          marginBottom: SpaceSm,
          wordBreak: "break-word"
        },
        variant: "SimpleList",
        children: wishLists.map((wishListItem, i) => {
          const wishListValue = wishListItem.value;
          const wishListText = (wishListItem == null ? void 0 : wishListItem.text) || "";
          if (i === wishLists.length - 1) {
            return /* @__PURE__ */ jsxs(
              ListItem,
              {
                sx: listItemStyles,
                children: [
                  /* @__PURE__ */ jsx(Divider, {}),
                  /* @__PURE__ */ jsx(
                    ListCheckBox,
                    {
                      dispatch,
                      selectedLists,
                      wishListText,
                      wishListValue
                    }
                  ),
                  /* @__PURE__ */ jsx(Divider, {})
                ]
              },
              wishListValue
            );
          } else {
            return /* @__PURE__ */ jsxs(
              ListItem,
              {
                sx: listItemStyles,
                children: [
                  /* @__PURE__ */ jsx(Divider, {}),
                  /* @__PURE__ */ jsx(
                    ListCheckBox,
                    {
                      dispatch,
                      selectedLists,
                      wishListText,
                      wishListValue
                    }
                  )
                ]
              },
              wishListValue
            );
          }
        })
      }
    ) : null,
    !showSticky && /* @__PURE__ */ jsx(SaveToListButton, { ...props })
  ] });
};
export {
  ListsUI
};
